module.exports = __webpack_public_path__ + "data/110m.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]&outputPath=data/!./src/data/110m.json
// module id = 31
// module chunks = 0